import { put } from 'redux-saga/effects';
import { unmarkHomeStartVideoApi } from 'common/api/videos';
import { reduxNotificationAction } from 'components/redux-notification/actions';
import { REDUX_NOTIFICATION_TYPES } from 'components/redux-notification';
import i18next from 'i18next';
import { updateHomeStartVideoAction } from 'components/mark-unmark-start-home-video';

export function* unmarkHomeStartVideoEffect({ payload: { video } }) {
  try {
    yield unmarkHomeStartVideoApi(video.id);

    yield put(updateHomeStartVideoAction(null));
    yield put(
      reduxNotificationAction(
        i18next.t('unmark_home_start_video_notification_success'),
        true,
        5,
        REDUX_NOTIFICATION_TYPES.SUCCESS
      )
    );
  } catch (error) {
    yield put(
      reduxNotificationAction(
        i18next.t('mark_channel_start_video_notification_error'),
        true,
        5,
        REDUX_NOTIFICATION_TYPES.ERROR
      )
    );
  }
}
